<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-10 14:35:50
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-01-03 15:23:48
 * @FilePath: /lobby/src/components/NavTab.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <van-sticky :offset-top="offSetTop" z-index="11">
    <div class="nav">
      <ul v-if="functionTabs.length > 1">
        <li :class="functionTabIndex == 0 ? 'nav_active' : ''" @click="selectFunctionTab()">
          <i class="bi bi-house"></i>
          <p>{{ $t('navBar.home') }}</p>
        </li>
        <li @click="showSportNavTab()" v-if="country == 'ET'">
          <i class="bi bi-person-arms-up"></i>
          <p>Sports</p>
        </li>
        <li
          v-for="(item, index) in functionTabs"
          :key="index"
          :class="functionTabIndex == index + 1 ? 'nav_active' : ''"
          @click="onSelectTab(index + 1, item)"
        >
          <i :class="`bi ${item.cover}`" v-if="item.name != 'PRAGMATIC'"></i>
          <p v-if="item.name != 'PRAGMATIC'">{{ formatNavTab(item.localName) }}</p>
          <img
            v-if="item.name == 'PRAGMATIC'"
            :src="`${resBaseUrl}${functionTabIndex == index + 1 ? 'icon_pp_act' : 'icon_pp'}.png`"
            alt=""
            style="width: 55%; margin: -0.33rem 0 -0.08rem 0"
          />
          <div style="height: 0.12rem" v-if="item.name == 'PRAGMATIC'"></div>
          <p
            v-if="item.name == 'PRAGMATIC'"
            style="
              word-wrap: break-word;
              word-break: break-all;
              margin-bottom: -0.12rem;
            "
          >
            {{ formatNavTab(item.localName) }}
          </p>
        </li>
        <li v-if="checkShowAPPDownloadBanner" @click="onDownLoadAPk">
          <i class="bi bi-download"></i>
          <p>{{ $t('appname') }}</p>
        </li>
        <li v-if="checkShowAPPDownloadBanner" @click="onSavePwa">
          <i class="bi bi-floppy-fill"></i>
          <p>{{ $t('pwaname') }}</p>
        </li>
      </ul>
    </div>
  </van-sticky>
</template>
<script>
import { BUS, POPUP } from '@/event/EventCenter'
import { SPORT_NAV_TAB_TYPE, useLobbyStore } from '@/stores/lobby.js'
import { useUserStore } from '@/stores/user'
import { mapActions, mapState } from 'pinia'
import { downloadAPK, formatNavTab, savePWA } from '@/utils/helper'
import { config } from '@/common/config'
export default {
  name: 'DhNavTab',
  computed: {
    ...mapState(useLobbyStore, [
      'functionTabs',
      'functionTabIndex',
      'hasStickyBanner',
      'checkShowAPPDownloadBanner'
    ]),
    ...mapState(useUserStore, ['isLogin', 'country'])
  },
  data() {
    return {
      offSetTop: 56,
      resBaseUrl: config.resBaseUrl
    }
  },
  watch: {
    hasStickyBanner(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.offSetTop = this.checkShowAPPDownloadBanner
          ? newvalue
            ? 133
            : 105
          : newvalue
            ? 86
            : 60
      }
    },
    checkShowAPPDownloadBanner(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.offSetTop = newvalue ? 86 : 60
      }
    }
  },
  mounted() {
    this.offSetTop = this.checkShowAPPDownloadBanner
      ? this.hasStickyBanner
        ? 133
        : 105
      : this.hasStickyBanner
        ? 86
        : 60
  },
  methods: {
    formatNavTab,
    ...mapActions(useLobbyStore, { selectFunctionTab: 'selectFunctionTab' }),
    onSelectTab(index, item) {
      if (['history', 'collect'].includes(item.name.toLowerCase()) && !this.isLogin) {
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'NavTab', to: POPUP.LOGIN, show: true })
      } else {
        this.selectFunctionTab(index)
        this.$bus.$emit(BUS.UPDATE_GAME_LIST)
      }
    },
    showSportNavTab(){
      useLobbyStore().navtabType = SPORT_NAV_TAB_TYPE
    },
    onDownLoadAPk() {
      downloadAPK(this.country)
    },
    onSavePwa() {
      savePWA()
    }
  }
}
</script>
<style lang="scss" scoped>
.nav {
  display: flex;
  width: 100%;
  height: 1.1rem;
  background-color: #000;
  padding: 1.5% 3%;
  margin-left: -0.1rem;
  margin-top: -0.3rem;
  // overflow: hidden;

  ul {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    // overflow: scroll;
    // white-space: nowrap;
    margin: 0px;
    padding-right: 3%;
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
    overflow-x: scroll;
    overflow-y: hidden;
  }

  li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.24rem;
    color: #ceb45f;
    text-align: center;
    // display: inline-block;
    display: -moz-inline-stack;
    min-width: 1.05rem !important;
    min-height: 0.85rem !important;
    margin: 0;
    padding: 0.1rem;
    border-radius: 0.2rem;
    border: 0.02rem solid #000;

    i {
      font-size: 0.48rem;
      color: #ceb45f;
    }

    p {
      width: max-content;
      line-height: 0;
      margin: 0.14rem 0;
      padding: 0;
    }
  }

  .nav_active {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #ffddac !important;
    // color: #ffddac !important;
    min-width: 1.05rem !important;
    min-height: 0.85rem !important;

    i {
      color: #ffddac !important;
    }

    p {
      color: #ffddac !important;
    }
  }
}
</style>
